import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "relative rounded-lg overflow-hidden",
  style: {"border":"1px solid #e5e7eb","background":"#fff"}
}
const _hoisted_2 = {
  class: "flex flex-wrap items-center gap-0.5 px-3 py-2",
  style: {"border-bottom":"1px solid #f3f4f6","background":"#f9fafb"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z" })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z" })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z" })
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "w-px h-5 mx-1",
  style: {"background":"#e5e7eb"}
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-bold" }, "H2", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-bold" }, "H3", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "w-px h-5 mx-1",
  style: {"background":"#e5e7eb"}
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z" })
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z" })
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z" })
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z" })
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "w-px h-5 mx-1",
  style: {"background":"#e5e7eb"}
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z" })
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M17 7h-4v2h4c1.65 0 3 1.35 3 3s-1.35 3-3 3h-4v2h4c2.76 0 5-2.24 5-5s-2.24-5-5-5zm-6 8H7c-1.65 0-3-1.35-3-3s1.35-3 3-3h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-2zm-3-4h8v2H8v-2z" })
], -1)
const _hoisted_17 = {
  key: 0,
  class: "flex items-center gap-2 px-4 py-2",
  style: {"border-bottom":"1px solid #f3f4f6","background":"#eff6ff"}
}
const _hoisted_18 = ["onKeydown"]
const _hoisted_19 = {
  class: "px-5 py-4",
  style: {"min-height":"320px","max-height":"560px","overflow-y":"auto"}
}
const _hoisted_20 = {
  class: "flex items-center justify-between px-5 py-2",
  style: {"border-top":"1px solid #f3f4f6","background":"#f9fafb"}
}
const _hoisted_21 = {
  class: "flex items-center gap-3 text-xs font-mono",
  style: {"color":"#6b7280"}
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { key: 3 }
const _hoisted_26 = { key: 4 }
const _hoisted_27 = { key: 5 }
const _hoisted_28 = { key: 6 }
const _hoisted_29 = {
  class: "text-xs font-mono",
  style: {"color":"#9ca3af"}
}

import { ref, watch, computed, nextTick, onBeforeUnmount, defineComponent, h } from 'vue';
import { useEditor, EditorContent } from '@tiptap/vue-3';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import Link from '@tiptap/extension-link';
import Image from '@tiptap/extension-image';
import Placeholder from '@tiptap/extension-placeholder';


export default /*#__PURE__*/_defineComponent({
  __name: 'TiptapEditor',
  props: {
    modelValue: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({ (e: 'update:modelValue', v: string): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: string };




const showLinkInput = ref(false);
const linkUrl       = ref('');
const linkInputRef  = ref<HTMLInputElement | null>(null);

const ToolBtn = defineComponent({
  props: { active: Boolean, title: String },
  emits: ['click'],
  setup(props, { slots, emit }) {
    return () => h('button', {
      type: 'button',
      title: props.title,
      onClick: () => emit('click'),
      style: props.active
        ? 'background:#6CC551;color:#fff;padding:6px;border-radius:6px;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;'
        : 'background:transparent;color:#374151;padding:6px;border-radius:6px;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;',
    }, slots.default?.());
  },
});

const editor = useEditor({
  extensions: [
    StarterKit.configure({ heading: { levels: [2, 3] } }),
    Underline,
    Link.configure({ openOnClick: false }),
    Image.configure({ HTMLAttributes: { class: 'rounded-lg max-w-full' } }),
    Placeholder.configure({ placeholder: 'Write the post content here…' }),
  ],
  content: props.modelValue || '',
  onUpdate({ editor: e }) {
    emit('update:modelValue', e.getHTML());
  },
  immediatelyRender: false,
});

watch(() => props.modelValue, (val) => {
  if (!editor.value) return;
  const current = editor.value.getHTML();
  if (val !== current) editor.value.commands.setContent(val || '', false);
});

const wordCount = computed(() => {
  if (!editor.value) return 0;
  return editor.value.getText().split(/\s+/).filter(Boolean).length;
});

const toggleLink = async () => {
  if (!editor.value) return;
  linkUrl.value = (editor.value.getAttributes('link').href as string) || '';
  showLinkInput.value = true;
  await nextTick();
  linkInputRef.value?.focus();
};

const applyLink = () => {
  if (!editor.value) return;
  if (linkUrl.value) {
    editor.value.chain().focus().setLink({ href: linkUrl.value }).run();
  } else {
    editor.value.chain().focus().unsetLink().run();
  }
  showLinkInput.value = false;
  linkUrl.value = '';
};

onBeforeUnmount(() => editor.value?.destroy());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(ToolBtn), {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(editor)?.chain().focus().toggleBold().run())),
        active: _unref(editor)?.isActive('bold'),
        title: "Bold"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["active"]),
      _createVNode(_unref(ToolBtn), {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(editor)?.chain().focus().toggleItalic().run())),
        active: _unref(editor)?.isActive('italic'),
        title: "Italic"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["active"]),
      _createVNode(_unref(ToolBtn), {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(editor)?.chain().focus().toggleUnderline().run())),
        active: _unref(editor)?.isActive('underline'),
        title: "Underline"
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["active"]),
      _hoisted_6,
      _createVNode(_unref(ToolBtn), {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(editor)?.chain().focus().toggleHeading({ level: 2 }).run())),
        active: _unref(editor)?.isActive('heading', { level: 2 }),
        title: "Heading 2"
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["active"]),
      _createVNode(_unref(ToolBtn), {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(editor)?.chain().focus().toggleHeading({ level: 3 }).run())),
        active: _unref(editor)?.isActive('heading', { level: 3 }),
        title: "Heading 3"
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["active"]),
      _hoisted_9,
      _createVNode(_unref(ToolBtn), {
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(editor)?.chain().focus().toggleBulletList().run())),
        active: _unref(editor)?.isActive('bulletList'),
        title: "Bullet list"
      }, {
        default: _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      }, 8, ["active"]),
      _createVNode(_unref(ToolBtn), {
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(editor)?.chain().focus().toggleOrderedList().run())),
        active: _unref(editor)?.isActive('orderedList'),
        title: "Ordered list"
      }, {
        default: _withCtx(() => [
          _hoisted_11
        ]),
        _: 1
      }, 8, ["active"]),
      _createVNode(_unref(ToolBtn), {
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(editor)?.chain().focus().toggleBlockquote().run())),
        active: _unref(editor)?.isActive('blockquote'),
        title: "Quote"
      }, {
        default: _withCtx(() => [
          _hoisted_12
        ]),
        _: 1
      }, 8, ["active"]),
      _createVNode(_unref(ToolBtn), {
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(editor)?.chain().focus().toggleCodeBlock().run())),
        active: _unref(editor)?.isActive('codeBlock'),
        title: "Code block"
      }, {
        default: _withCtx(() => [
          _hoisted_13
        ]),
        _: 1
      }, 8, ["active"]),
      _hoisted_14,
      _createVNode(_unref(ToolBtn), {
        onClick: toggleLink,
        active: _unref(editor)?.isActive('link'),
        title: "Link"
      }, {
        default: _withCtx(() => [
          _hoisted_15
        ]),
        _: 1
      }, 8, ["active"]),
      (_unref(editor)?.isActive('link'))
        ? (_openBlock(), _createBlock(_unref(ToolBtn), {
            key: 0,
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(editor)?.chain().focus().unsetLink().run())),
            active: false,
            title: "Remove link"
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (showLinkInput.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _withDirectives(_createElementVNode("input", {
            ref_key: "linkInputRef",
            ref: linkInputRef,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((linkUrl).value = $event)),
            onKeydown: [
              _withKeys(_withModifiers(applyLink, ["prevent"]), ["enter"]),
              _cache[11] || (_cache[11] = _withKeys(($event: any) => (showLinkInput.value = false), ["escape"]))
            ],
            placeholder: "https://example.com",
            class: "flex-1 text-sm px-3 py-1.5 rounded-lg",
            style: {"border":"1px solid #e5e7eb","outline":"none","background":"#fff","color":"#111827"}
          }, null, 40, _hoisted_18), [
            [_vModelText, linkUrl.value]
          ]),
          _createElementVNode("button", {
            onClick: applyLink,
            class: "px-3 py-1.5 text-xs font-semibold rounded-lg text-white",
            style: {"background":"#6CC551","border":"none","cursor":"pointer"}
          }, "Set"),
          _createElementVNode("button", {
            onClick: _cache[12] || (_cache[12] = ($event: any) => (showLinkInput.value = false)),
            class: "px-3 py-1.5 text-xs rounded-lg",
            style: {"color":"#374151","border":"none","background":"transparent","cursor":"pointer"}
          }, "Cancel")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(_unref(EditorContent), {
        editor: _unref(editor),
        class: "tiptap-content"
      }, null, 8, ["editor"])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        (_unref(editor)?.isActive('bold'))
          ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Bold"))
          : _createCommentVNode("", true),
        (_unref(editor)?.isActive('italic'))
          ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Italic"))
          : _createCommentVNode("", true),
        (_unref(editor)?.isActive('heading', { level: 2 }))
          ? (_openBlock(), _createElementBlock("span", _hoisted_24, "H2"))
          : _createCommentVNode("", true),
        (_unref(editor)?.isActive('heading', { level: 3 }))
          ? (_openBlock(), _createElementBlock("span", _hoisted_25, "H3"))
          : _createCommentVNode("", true),
        (_unref(editor)?.isActive('blockquote'))
          ? (_openBlock(), _createElementBlock("span", _hoisted_26, "Quote"))
          : _createCommentVNode("", true),
        (_unref(editor)?.isActive('codeBlock'))
          ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Code"))
          : _createCommentVNode("", true),
        (_unref(editor)?.isActive('link'))
          ? (_openBlock(), _createElementBlock("span", _hoisted_28, "Link"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(wordCount)) + " words", 1)
    ])
  ]))
}
}

})